import React from 'react';

import { Flex, Group, Paper, Stack, Text, useMantineTheme } from '@mantine/core';
import {
  IconChevronRight,
  IconCircleFilled,
  IconClock,
  IconMapPin,
  IconUser,
  IconUsers,
} from '@tabler/icons-react';
import KiloButton from 'components/KiloButton';

interface IEventCardClass {
  title: string;
  returnStylesForStartsInStatuses: StartsInStatusesColors;
  startsIn: string;
  isEnded: boolean;
  eventDurationDateAndTime: string;
  coachNames: string;
  classAttendance: string;
  duration: number;
  location: string;
  workoutName: string | null;
  onClick: () => void;
  isDesktop?: boolean;
}

type StartsInStatusesColors = {
  text: string;
  background: string;
  border: string;
  borderWidth: string;
};

const EventCardClass = ({
  title,
  returnStylesForStartsInStatuses,
  startsIn,
  isEnded,
  eventDurationDateAndTime,
  coachNames,
  classAttendance,
  duration,
  location,
  onClick,
  isDesktop,
}: IEventCardClass): JSX.Element => {
  const theme = useMantineTheme();
  return (
    <Paper onClick={!isDesktop ? onClick : undefined}>
      <Group position='apart' mb={7}>
        <Group spacing='sm'>
          <Text weight={700} size={isDesktop ? 21 : 18}>
            {title}
          </Text>
        </Group>
        <Group
          bg={returnStylesForStartsInStatuses?.background}
          py={4}
          px={18}
          style={{ borderRadius: '12px', color: returnStylesForStartsInStatuses?.text }}
          spacing={16.5}
        >
          <Text weight={400} size={isDesktop ? theme.spacing.md : theme.spacing.sm}>
            {startsIn}
          </Text>
          {isEnded && <IconCircleFilled size={8} />}
        </Group>
      </Group>
      <Text weight={500} size={isDesktop ? 21 : 16}>
        {eventDurationDateAndTime}
      </Text>
      <Flex p={0} m={0} mt={14}>
        <Stack w={'100%'} spacing={14}>
          <Group spacing={8}>
            <IconUser size={isDesktop ? 21 : 16} />
            <Text weight={400} size={isDesktop ? 21 : 16}>
              {coachNames} (Coach)
            </Text>
          </Group>
          <Group spacing={8}>
            <IconUsers size={isDesktop ? 21 : 16} />
            <Text weight={400} size={isDesktop ? 21 : 16}>
              {classAttendance}
            </Text>
          </Group>
        </Stack>

        <Stack w={'80%'} spacing={14}>
          <Group spacing={8}>
            <IconClock size={isDesktop ? 21 : 16} />
            <Text weight={400} size={isDesktop ? 21 : 16}>
              {duration} Mins
            </Text>
          </Group>

          <Group spacing={8}>
            <IconMapPin size={isDesktop ? 21 : 16} />
            <Text weight={400} size={isDesktop ? 21 : 16}>
              {location}
            </Text>
          </Group>
        </Stack>

        <Group align='flex-end'>
          {isDesktop ? (
            <KiloButton w={'fit-content'} onClick={onClick}>
              <Text fw={600} size={18} transform='capitalize'>
                see class
              </Text>
            </KiloButton>
          ) : (
            <Group
              bg={'#E1F3FE'}
              w={isDesktop ? 48 : 35}
              h={isDesktop ? 48 : 35}
              style={{
                borderRadius: '50%',
                justifyContent: 'center',
                cursor: 'pointer',
                alignSelf: 'flex-start',
              }}
              onClick={onClick}
            >
              <IconChevronRight color='#15B8FF' type='default' />
            </Group>
          )}
        </Group>
      </Flex>
    </Paper>
  );
};

export default EventCardClass;
